import moment from 'moment-timezone';
import { Strings } from './Strings';
import { AppConfig } from '../../AppConfig';
import { AWSAmplifyHelper } from './AWSAmplifyHelper';
import { expandListFromFlatValues, usesFlatListStorage } from './ListFlatStorageHelper';

export class Helper {
  static HOUR_MS = 3600 * 1000
  static DAY_MS = 24 * 3600 * 1000
  static MILLISECOND_FOR_DAY = 24 * 60 * 60 * 1000

  static idSeparator() {
    return '-'
  }
  static inArray(arr, value) {
    if (!arr) return false
    return arr.indexOf(value) >= 0 ? true : false
  }
  static getString(key) {
    return Strings.getString(key) || key
  }
  static setLanguage(lang) {
    Strings.setLanguage(lang)
    // if (['ar'].indexOf(lang) >= 0) {
    //   I18nManager.forceRTL(true)
    // } else {
    //   I18nManager.forceRTL(false)
    // }
  }

  static validEmail(email) { //TODO: why?
    const result = email.replace(/\s/g, '')
    if (!/\S+@\S+\.\S+/.test(result)) {
      return false
    }
    return result.toLowerCase()
  }

  static getLanguage() {
    return Strings.getLanguage();
  }

  static getLanguageText(data, key) {
    const language = Strings.getLanguage();
    return data[key + '_' + language] || data[key];
  }
  static encodeQueryString = (data) => {
    const ret = [];
    for (const d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
    return ret.join('&');
  }
  static formatName(item) {
    let name = '';
    if (!item) {
      return name;
    }
    if (item.nametitle) {
      name += item.nametitle
      name += ' '
    }
    if (item.givenname) {
      name += item.givenname
      name += ' '
    }
    if (item.middlename) {
      name += item.middlename
      name += ' '
    }
    if (item.familyname) {
      name += item.familyname
    }
    return name;
  }
  static formatUserEmail(item) {
    const name = Helper.formatName(item)
    const email = item.email
    return `"${(name || '').trim()}"` + (email ? ` <${email}>` : '')
  }

  static isEmailOnlyFormat(emailString) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(emailString)) {
      return true
    }
    return false
  }

  static formatUserEmailToQuotedNameFormat(userEmail) {
    if(!Helper.isEmailOnlyFormat(userEmail)) {
      const regex = /^"([^"]+)" <(.+)>$/;
      const match = userEmail.match(regex);

      if (match) {
        return userEmail;
      }
      const [name, email] = userEmail.split(' <');
      return `"${name.trim()}" <${email}`;
    }
    return userEmail
  }

  static INBOX_ERROR_FALLBACKS = {
    inboxDisabledError: 'This inbox is disabled and cannot be used for enrolment or send.',
    inboxDisconnectedError: 'This inbox is disconnected. Reconnect SMTP/IMAP before using it.',
    inboxNotMarketingError: 'This inbox is not marked as Marketing and cannot be used for bulk enrolment.',
    inboxCategoryError: 'This inbox has no Marketing or CRM category.',
  }

  static getErrorMsg(error) {
    let message;
    if (typeof error === 'string') {
      message = error;
    }
    if (!message) {
      if (error) {
        if (error.original && error.original.bodyJson) {
          const body = error.original.bodyJson;
          if (body && body.code && body.message) {
            message = body.message;
          } else if (body && body.code && Helper.INBOX_ERROR_FALLBACKS[body.code]) {
            message = Helper.INBOX_ERROR_FALLBACKS[body.code];
          }
        }
        if (!message) {
          message = error.message;
        }
        if (!message) {
          message = error.description;
        }
      }
    }
    return message || Helper.getString('customerCareErr');
  }
  static showProgressModal(caller) {
    caller.setState({ progressModelOpen: true });
  }
  static hideProgressModal(caller) {
    caller.setState({ progressModelOpen: false });
  }
  static formatTimestamp(utcTimestamp) {
    return moment.utc(utcTimestamp).local().format('Do MMM YYYY, h:mm a');
  }
  static joinWithAnd(arr) {
    if (arr.length === 0) {
      return '';
    } else if (arr.length === 1) {
      return arr[0];
    } else {
      const firstElements = arr.slice(0, arr.length - 1);
      const lastElement = arr[arr.length - 1];
      return firstElements.join(', ') + ' and ' + lastElement;
    }
  }
  static formatDate(utcTimestamp) {
    return moment.utc(utcTimestamp).local().format('Do MMM YYYY');
  }
  static formatDate2(options) {
    const { utcTimestamp, zone, format } = options
    return moment.unix(utcTimestamp / 1000).tz(zone || AppConfig.DEFAULT_ZONEINFO).format(format || 'DD-MMM-YYYY')
  }

  static formatDuration(ms) {
    const absMs = Math.abs(ms)
    const seconds = Math.floor(absMs / 1000)
    const sign = ms < 0 ? '-' : ''

    if (seconds === 0) {
      const milliCount = Math.floor(absMs)
      return sign + milliCount + ' millisecond' + (milliCount === 1 ? '' : 's')
    }

    const absSeconds = seconds
    const units = [
      { label: 'year', value: 365 * 24 * 60 * 60 },
      { label: 'month', value: 30 * 24 * 60 * 60 },
      { label: 'day', value: 24 * 60 * 60 },
      { label: 'hour', value: 60 * 60 },
      { label: 'minute', value: 60 },
      { label: 'second', value: 1 }
    ]

    for (let i = 0; i < units.length; i++) {
      const unitSeconds = units[i].value

      if (absSeconds >= unitSeconds) {
        const count = Math.floor(absSeconds / unitSeconds);
        return sign + count + ' ' + units[i].label + (count > 1 ? 's' : '');
      }
    }

    return '0 milliseconds';
  }

  static revertDurationFormatting(str) {
    if (!str || typeof str !== 'string') return 0

    const input = str.trim().toLowerCase()

    const units = {
      year: 365 * 24 * 60 * 60 * 1000,
      years: 365 * 24 * 60 * 60 * 1000,
      month: 30 * 24 * 60 * 60 * 1000,
      months: 30 * 24 * 60 * 60 * 1000,
      day: 24 * 60 * 60 * 1000,
      days: 24 * 60 * 60 * 1000,
      hour: 60 * 60 * 1000,
      hours: 60 * 60 * 1000,
      minute: 60 * 1000,
      minutes: 60 * 1000,
      second: 1000,
      seconds: 1000,
      millisecond: 1,
      milliseconds: 1
    }

    const parts = input.split(' ')
    if (parts.length < 2) return 0

    const value = parseInt(parts[0], 10)
    const unit = parts[1]

    if (isNaN(value) || !units[unit]) return 0

    return value * units[unit]
  }
  static formatDurationExact(ms) {
    if (ms === null || ms === undefined || ms === '' || Number.isNaN(Number(ms)) || ms === 0 || ms === '0') {
      return '0 milliseconds'
    }

    const absMs = Math.abs(Number(ms))
    const sign = Number(ms) < 0 ? '-' : ''
    
    const units_to_ms = {
      years: 365 * 24 * 60 * 60 * 1000,
      months: 30 * 24 * 60 * 60 * 1000,
      weeks: 7 * 24 * 60 * 60 * 1000,
      days: 24 * 60 * 60 * 1000,
      hours: 60 * 60 * 1000,
      minutes: 60 * 1000,
      seconds: 1000,
      milliseconds: 1,
    }

    const units = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds', 'milliseconds']
    
    for (const unit of units) {
      if (absMs % units_to_ms[unit] === 0) {
        const count = Math.floor(absMs / units_to_ms[unit])
        const singular = unit.endsWith('s') ? unit.slice(0, -1) : unit
        const displayUnit = count === 1 ? singular : unit
        return `${sign}${count} ${displayUnit}`
      }
    }
    
    return `${sign}${Math.floor(absMs)} milliseconds`
  }
  static populateFormDefinitionValues(formDefinition, values) {
    for (const field of formDefinition.steps[0].fields) {
      if (field.type === 'list' && usesFlatListStorage(field)) {
        field.value = expandListFromFlatValues(values, field)
        continue
      }
      if (values.__STAGED && field.key in values.__STAGED) {
        field.pendingApproval = true
        Helper.assignFieldValue(field, values.__STAGED)
      } else if (field.key in values) {
        Helper.assignFieldValue(field, values)
      } else {
        delete field.value;
        delete field.link;
      }
    }
  }
  static assignFieldValue(field, values) {
    field.value = values[field.key]
    if (field.type === 'radio' && Array.isArray(field.value)) {
      if (field.value.length > 0) {
        field.value = field.value[0]
      } else {
        delete field.value
      }
    }
    if (field.linkName) {
      field.link = values[field.linkName]
    }
  }
  static deleteFormDefinitionValues(formDefinition) {
    for (const field of formDefinition.steps[0].fields) {
      delete field.value;
      if (field.imageUpload === true) { //retained for backward compatibility
        field.link = null;
      }
      if (field.subType === 'image') {
        field.link = null;
      }
      if (field.documentUpload === true) { //retained for backward compatibility
        field.link = null;
      }
      if (field.subType === 'document') {
        field.link = null;
      }
    }
  }
  static validateAndFormatEmail(email) {
    const result = email.replace(/\s/g, '')
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(result)) {
      throw new Error(Helper.getString('invalidEmailFormat'));
    }
    return result.toLowerCase()
  }
  static formatCurrency(value, currency) {
    return Helper.getLanguage() === 'ar'
      ? (currency || AppConfig.DEFAULT_CURRENCY) + ' ' + String(Number(value / 100).toFixed(2))
      : String(Number(value / 100).toFixed(2)) + ' ' + (currency || AppConfig.DEFAULT_CURRENCY);
  }
  static dictToArray(dict) {
    const arr = []
    if (!dict) {
      return arr
    }
    Object.keys(dict).forEach(k => {
      arr.push(dict[k])
    })
    return arr
  }
  static itemsToMap(items, idName) {
    const itemMap = {}
    idName = idName || 'id'
    for (const i of items) {
      itemMap[i[idName]] = i
    }
    return itemMap;
  }
  static sortDictArray(docs, attr) {
    const attrName = attr || 'order'
    return docs.sort((a, b) => {
      if (!a[attrName]) {
        return -1
      }
      if (!b[attrName]) {
        return 1
      }
      return String(a[attrName]).localeCompare(String(b[attrName]))
    })
  }
  static sortDictArrayRev(docs, attr) {
    const attrName = attr || 'order'
    return docs.sort((a, b) => {
      if (!a[attrName]) {
        return 1
      }
      if (!b[attrName]) {
        return -1
      }
      return b[attrName].localeCompare(a[attrName])
    })
  }

  static processCats(cats, listRootsAlso) {
    const catsById = Helper.itemsToMap(cats, 'id')
    const catsWhichAreParents = {}
    cats.forEach(i => {
      i.parents = []
      let k = i
      let depth = 0
      while (!k.parentId.startsWith('ROOT')) {
        catsWhichAreParents[k.parentId] = k // Has atleast one child
        i.parents.unshift(k.parentId)
        k = catsById[k.parentId]
        if (!k) break
        depth += 1; if (depth >= 5) break // loop braker - just in case
      }
    })

    const leafCats = []
    cats.forEach(i => {
      i.fullPath = ''
      i.parents.forEach(p => {
        if (!catsById[p]) return
        i.fullPath += catsById[p].title + '/'
      })
      i.fullPath += i.title

      i.titleOriginal = i.title
      i.title = i.fullPath
      if (!(i.id in catsWhichAreParents)) {
        leafCats.push(i)
      } else if (listRootsAlso) {
        leafCats.push(i)
      }
    })
    return Helper.sortAscending(leafCats, 'title')
  }

  static sortAscending(arr, key) {
    key = key || 'order'
    return arr.sort((a, b) => { return a[key].localeCompare(b[key]) })
  }

  static pretty(obj) {
    return JSON.stringify(obj, null, 2) + '\n';
  }

  static currentTs() {
    return Math.floor(new Date()); // Millisecs since epoch
  }

  static promisify(f) {
    const util = require('util')
    return util.promisify(f)
  }

  static selectDict(names, src) {
    const dest = {}
    const ns = names.split(',').map(v => v.trim())
    ns.forEach(n => {
      if (n in src) {
        dest[n] = src[n]
      }
    })
    return dest
  }

  static ellipsis(input, maxLength = 30) {
    if (!input) return input
    if (input.length > maxLength) {
      return input.substring(0, maxLength) + '...';
    }
    return input
  }

  static fieldDefResolve(options) {
    console.log('fieldDefResolve:', options)
    const { def, values, key } = options
    let resolved = values[key]
    if (!def) return resolved
    def.steps[0].fields.forEach(field => {
      if (field.key !== key) return
      if (!field.options) return
      const optionsByKey = Helper.itemsToMap(field.options, 'key')
      const value = values[key]
      if (value) {
        if (field.type === 'radio') {
          const option = optionsByKey[value]
          if (option) {
            resolved = option.label || option.text || option.title
            return
          }
        } else if (field.type === 'check_box') {
          const resolves = []
          value.forEach(v => {
            const option = optionsByKey[v]
            if (option) resolves.push(option.label || option.text || option.title)
          })
          if (resolves.length > 0) {
            resolved = resolves.join(', ')
            return
          }
        }
      }
    })
    return resolved
  }

  static abbrNum(number) {
    // if (number >= 100000) {
    //   return (number / 100000).toFixed(1) + 'L'
    // } else if (number >= 1000) {
    //   return Math.round(number / 1000) + 'K'
    // }
    // return Math.round(number)
    return Math.round(number).toLocaleString('en-IN')
  }

  static makeFieldsCopy = (sourceFields, options) => {
    const fieldsCopy = {
      formType: options.formType,
      steps: [
        {
          fields: []
        }
      ]
    }
    for (const f of sourceFields) {
      const fDetail = {}
      for (const key in f) {
        fDetail[key] = f[key]
      }
      fieldsCopy.steps[0].fields.push(fDetail)
    }
    return fieldsCopy
  }

  static amplifyEventPageView(options) {
    AWSAmplifyHelper.eventPageView(options)
  }

  static amplifyEvent(options) {
    AWSAmplifyHelper.event(options)
  }

  static getYoutubeVideoId(ytLink) {
    const Url = require('url-parse')
    const url = new Url(ytLink, true)
    let videoId
    if(url.host !== 'www.youtube.com' && url.host !== 'youtu.be') return videoId
    if (url.hostname.endsWith('.be')) {
      videoId = url.pathname.substring(1)
    } else {
      videoId = url.query.v
    }
    return videoId
  }

  static extractAttrs(crmContactAttrs, attrKey) {
    return ((crmContactAttrs && crmContactAttrs[attrKey]) || '').split(',').map(t => t.trim()).filter(a => !!a)
  }
  static loadAttrOptions(fieldDef, crmContactAttrs, attrKey, fieldKey) {
    if (!fieldKey) fieldKey = attrKey
    const extractedAttrs = this.extractAttrs(crmContactAttrs, attrKey)
    const uniqueAttrs = Array.isArray(extractedAttrs) ? [...new Set(extractedAttrs)] : extractedAttrs
    const field = fieldDef.steps[0].fields.find(f => f.key === fieldKey)
    if (field) field.options = uniqueAttrs.map(t => ({key: t, label: t}))
  }

  /** Format free-form addOptions input (e.g. tagformat, lowercase). */
  static formatAddOptionInput(rawValue, formatter) {
    const trimmed = String(rawValue || '').trim()
    if (!trimmed) return ''
    if (formatter === 'tagformat') {
      return trimmed
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .replace(/_+/g, '_')
    }
    if (formatter === 'lowercase') {
      return trimmed.toLowerCase()
    }
    return trimmed
  }

  /** Normalize a stored field value using the same rules as addOptions formatters. */
  static formatAddOptionFieldValue(value, formatter) {
    if (value == null || value === '') return value
    if (formatter === 'lowercase') {
      if (Array.isArray(value)) {
        return value.map(v => (v == null || v === '') ? v : String(v).trim().toLowerCase())
      }
      return String(value).trim().toLowerCase()
    }
    if (formatter === 'tagformat') {
      if (Array.isArray(value)) {
        return value.map(v => Helper.formatAddOptionInput(v, 'tagformat')).filter(Boolean)
      }
      return Helper.formatAddOptionInput(value, 'tagformat')
    }
    return value
  }

  static getAutocompleteOptionLabel(option) {
    if (!option) return ''
    if (option.key) return option.label || option.text || String(option.key)
    return option.label || option.text || (option.value != null ? String(option.value) : '')
  }

  /**
   * When the input still shows the current selection (or is empty), keep the full option list so
   * opening the dropdown is not reduced to one row. Otherwise allow normal type-to-filter.
   */
  static shouldShowFullEntityAutocompleteCatalog(inputValue, selectedValue, multiSelect, getOptionLabel) {
    const trimmed = String(inputValue || '').trim()
    if (!trimmed) return true
    const getLabel = getOptionLabel || Helper.getAutocompleteOptionLabel
    if (multiSelect) {
      if (!Array.isArray(selectedValue) || selectedValue.length === 0) return false
      return selectedValue.some((opt) => getLabel(opt) === trimmed)
    }
    if (!selectedValue) return false
    const selected = Array.isArray(selectedValue) ? selectedValue[0] : selectedValue
    return getLabel(selected) === trimmed
  }

  /**
   * Entity add/edit Autocomplete: skip narrowing only while the input matches the selected label.
   * Optional addOptions "Add …" row when typing.
   */
  static buildEntityFormAutocompleteFilterOptions(options, params, {
    addOptions,
    addOptionsFormatter,
    formatAddOptionInput,
    filterOptionsFn,
    selectedValue,
    multiSelect,
    getOptionLabel,
  } = {}) {
    let list = Array.isArray(options) ? [...options] : []
    if (typeof filterOptionsFn === 'function') {
      const inputValue = params && params.inputValue != null ? params.inputValue : ''
      if (!Helper.shouldShowFullEntityAutocompleteCatalog(inputValue, selectedValue, multiSelect, getOptionLabel)) {
        list = filterOptionsFn(list, params)
      }
    }
    if (!addOptions) {
      return list
    }
    const inputValue = params && params.inputValue != null ? String(params.inputValue).trim() : ''
    if (!inputValue || typeof formatAddOptionInput !== 'function') {
      return list
    }
    const formattedValue = formatAddOptionInput(inputValue, addOptionsFormatter)
    if (!formattedValue) {
      return list
    }
    const isExisting = list.some((option) => {
      if (!option) return false
      const optLabel = option.text || option.label || option.key
      return inputValue === optLabel || formattedValue === optLabel || formattedValue === option.key
    })
    if (!isExisting) {
      list.unshift({
        value: formattedValue,
        text: `Add "${formattedValue}"`,
      })
    }
    return list
  }
  static getField(fieldDef, attrKey) {
    return fieldDef.steps[0].fields.find(f => f.key === attrKey)
  }

  /** All form fields whose `key` equals `fieldKey` (e.g. duplicate keys across conditional steps). */
  static getFields(fieldDef, fieldKey) {
    if (!fieldDef || !fieldDef.steps || fieldDef.steps.length === 0 || !fieldDef.steps[0].fields || !fieldKey) {
      return []
    }
    return fieldDef.steps[0].fields.filter(f => f.key === fieldKey)
  }
  static nextNonClashingIndexedName(prefix, existingNames) {
    const taken = new Set((existingNames || []).map(t => String(t || '')))
    let n = 1
    let candidate = `${prefix}${n}`
    while (taken.has(candidate)) {
      n += 1
      candidate = `${prefix}${n}`
    }
    return candidate
  }
  static getCustomField(fieldDef, _uiKey) {
    if(fieldDef && fieldDef.steps && fieldDef.steps.length > 0 && fieldDef.steps[0].fields && _uiKey) {
      return fieldDef.steps[0].fields.find(f => f._uiKey === _uiKey)
    }
    return null
  }

  static getFilteredFieldDef(fieldDef, attrKeys) {
    const filteredFieldDef = fieldDef
    if(fieldDef && fieldDef.steps && fieldDef.steps.length > 0 && fieldDef.steps[0].fields && Array.isArray(attrKeys) && attrKeys.length > 0) {
      filteredFieldDef.steps[0].fields =  fieldDef.steps[0].fields.filter(f => {
        const matchKey = f._uiKey ? f._uiKey : f.key
        return attrKeys.includes(matchKey)
      })
    }
    return filteredFieldDef
  }

  static removeFieldsFromFieldDef(fieldDef, attrKeys) {
    const filteredFieldDef = fieldDef
    if(fieldDef && fieldDef.steps && fieldDef.steps.length > 0 && fieldDef.steps[0].fields && Array.isArray(attrKeys) && attrKeys.length > 0) {
      filteredFieldDef.steps[0].fields =  fieldDef.steps[0].fields.filter(f => {
        const matchKey = f._uiKey ? f._uiKey : f.key
        return !attrKeys.includes(matchKey)
      })
    }
    return filteredFieldDef
  }

  static removeAdvancedFields(fieldDef) {
    if (!fieldDef || !fieldDef.steps || fieldDef.steps.length === 0 || !fieldDef.steps[0].fields) {
      return fieldDef
    }

    const currentFieldDef = JSON.parse(JSON.stringify(fieldDef))
    currentFieldDef.steps[0].fields = currentFieldDef.steps[0].fields.filter((field) => {
      return !field.advanced
    })

    return currentFieldDef
  }

  static getFilterOption(filterOptions, key) {
    if(Array.isArray(filterOptions) && filterOptions.length > 0) {
      return filterOptions.find(option => option.key === key)
    }
    return null
  }

  static getAllowedFormatsFromImageField(imageField) {
    let allowedFormats = null
    if(imageField && imageField.uploadAccept) {
      allowedFormats = imageField.uploadAccept
        .split(',')
        .map((format) => {
          const value = format.trim().toLowerCase()
          const parts = value.split('/')
          return parts.length === 2 ? parts[1] : value
        }).filter(Boolean)
    }
    return allowedFormats
  }

  static renderHtmlOrPlainText(value) {
    if (typeof value !== 'string' || value.trim() === '') {
      return ''
    }
    try {
      const parsed = JSON.parse(value)
      if (parsed && typeof parsed === 'object' && parsed.__azformatted) {
        const draftToHtml = require('draftjs-to-html')
        return draftToHtml(parsed.__azformatted)
      }
      return this.escapeHtml(value)

    } catch (e) {
      return this.escapeHtml(value)
    }
  }

  static renderHtmlText(richText) {
    try {
      const parsedText = JSON.parse(richText)
      if (parsedText.__azformatted) {
        const draftToHtml = require('draftjs-to-html');
        return draftToHtml(parsedText.__azformatted)
      }
    } catch (e) { console.log('renderHtmlText error: ', e) }
    return ''
  }
  static renderPlainText(richText) {
    try {
      const parsedText = JSON.parse(richText)
      if (parsedText.__azformatted) {
        const entityMap = parsedText.__azformatted.entityMap;
        return parsedText.__azformatted.blocks.reduce((p, c, i) => {
          let entityText = '';
          const prefix = c.type === 'unordered-list-item' ? '- ' : '';
          if (c.entityRanges.length) {
            const entityIndex = c.entityRanges[0].key;
            const entity = entityMap[entityIndex];
            if (entity.type === 'LINK' && entity.data) {
              entityText = ': ' + entity.data.url || ''
            }
          }
          return (i === 0 ? '' : '\n') + p + prefix + c.text + entityText
        }, '')
      }
    } catch (e) { console.log('renderPlainText error: ', e) }
    return ''
  }
  static replaceRichText(richText, templateValues) {
    try {
      const richTextCopy = JSON.parse(richText)
      richTextCopy.__azformatted.blocks = richTextCopy.__azformatted.blocks.map(b => this.replaceRichTextBlock(b, templateValues));
      Object.values(richTextCopy.__azformatted.entityMap || {}).forEach(e => {
        if (e.data && e.data.url) {
          e.data.url = this.replaceText(e.data.url, templateValues);
        }
      });
      return JSON.stringify(richTextCopy);
    } catch (err) {
      console.error(err)
    }
    return richText || ''
  }
  static replaceRichTextBlock(block, templateValues) {
    const blockCopy = JSON.parse(JSON.stringify(block));
    let replacementsDiff = 0;
    blockCopy.text = blockCopy.text.replace(/{{([a-zA-Z][a-zA-Z0-9_().]*)\s*(,\s*([^{}]*))?}}/g, (...args) => {
      const fullMatch = args[0]
      const match = args.length >= 2 ? args[1] : '';
      let replacement = args.length >= 4 ? args[3] : args[0];
      if (match && match in templateValues) {
        replacement = templateValues[match];
      }
      const matchStart = args[4] + replacementsDiff;
      const matchLength = fullMatch.length
      const matchEnd = matchStart + matchLength - 1;

      if (replacement) {
        const replacementStart = matchStart;
        const replacementEnd = replacementStart + replacement.length - 1;

        const lengthDiff = replacement.length - matchLength;

        const listOfRanges = [blockCopy.inlineStyleRanges, blockCopy.entityRanges];
        listOfRanges.forEach(ranges => {
          ranges.forEach(range => {
            if (range.length <= 0) return;

            let rangeStart = range.offset;
            let rangeEnd = rangeStart + range.length - 1;

            if (matchStart > rangeEnd) {
              // case when range is before the match - no op
            } else if (matchEnd < rangeStart) {
              // case when range is after the match
              rangeStart += lengthDiff;
              rangeEnd += lengthDiff;
            } else {
              // case when range and match overlap
              // in this case, we apply the range to the entire replacement
              rangeStart = Math.min(rangeStart, replacementStart)
              rangeEnd = Math.max(rangeEnd, matchEnd) + lengthDiff;
            }

            range.offset = rangeStart;
            range.length = rangeEnd - rangeStart + 1;
          })
        })

        replacementsDiff += lengthDiff;

        return replacement;
      }
      return args[0];
    });
    return blockCopy;
  }
  static mergeRichText(richText1, richText2) {
    try {
      const parsedText1 = richText1 ? JSON.parse(richText1) : ''
      const parsedText2 = richText2 ? JSON.parse(richText2) : ''
      const mergedRichText = parsedText1
      if (mergedRichText.__azformatted && parsedText2.__azformatted && mergedRichText.__azformatted.blocks && parsedText2.__azformatted.blocks) {
        const newBlocks = JSON.parse(JSON.stringify(parsedText2.__azformatted.blocks))
        if (mergedRichText.__azformatted.entityMap && parsedText2.__azformatted.entityMap) {
          let lastEntityKeyIndex = Object.keys(mergedRichText.__azformatted.entityMap).reduce((p, c) => Number.parseInt(c) > p ? Number.parseInt(c) : p, -1)
          const newEntityMap = {}
          Object.keys(parsedText2.__azformatted.entityMap).forEach(entityKey => {
            lastEntityKeyIndex = lastEntityKeyIndex + 1
            const newKey = `${lastEntityKeyIndex}`
            newEntityMap[newKey] = parsedText2.__azformatted.entityMap[entityKey]
            parsedText2.__azformatted.blocks.forEach((oldBlock, blockIndex) => {
              const newBlock = newBlocks[blockIndex]
              oldBlock.entityRanges.forEach((oldRange, rangeIndex) => {
                const newRange = newBlock.entityRanges[rangeIndex]
                if (oldRange.key == entityKey) {
                  newRange.key = lastEntityKeyIndex
                }
              })
            })
          })
          Object.assign(mergedRichText.__azformatted.entityMap, newEntityMap)
        }
        mergedRichText.__azformatted.blocks.push(...newBlocks)
      }
      return JSON.stringify(mergedRichText)
    } catch (e) { console.log('mergeRichText error: ', e) }
    return richText1
  }
  static htmlToRichText(htmlText) {
    try {
      const { convertFromHTML, convertToRaw, ContentState } = require('draft-js')
      const blocksFromHTML = convertFromHTML(htmlText)
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap,
      );
      return JSON.stringify({ __azformatted: convertToRaw(contentState) })
    } catch (e) { console.log('htmlToRichText error: ', e) }
    return ''
  }
  static extractEmailAddress(rawEmailAddress) {
    const re = /[^< ]+(?=>)/g;
    const matches = rawEmailAddress.match(re)
    return (matches && matches.length > 0) ? matches[0] : rawEmailAddress
  }
  static isEmailEqual(addr1, addr2) {
    return this.extractEmailAddress(addr1) === this.extractEmailAddress(addr2)
  }
  static replaceText(text, templateValues) {
    return text.replace(/{{([a-zA-Z][a-zA-Z0-9_().]*)\s*(,\s*([^{}]*))?}}/g, (...args) => {
      const match = args.length >= 2 ? args[1] : '';
      const fallbackVal = args.length >= 4 ? args[3] : args[0];
      if (match && match in templateValues) {
        return templateValues[match];
      }
      return fallbackVal || '';
    });
  }
  static addRichTextUrlQueryParams(richText, qs) {
    try {
      const richTextCopy = JSON.parse(richText)
      Object.values(richTextCopy.__azformatted.entityMap || {}).forEach(e => {
        if (e.data && e.data.url && qs) {
          const modUrl = new URL(e.data.url)
          Object.entries(qs).forEach(qse => modUrl.searchParams.set(qse[0], qse[1]))
          e.data.url = modUrl.href
        }
      });
      return JSON.stringify(richTextCopy);
    } catch (err) {
      console.log(err)
    }
    return richText
  }
  static addHtmlTextUrlQueryParams(htmlText, qs) {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlText, 'text/html');
      const anchors = doc.getElementsByTagName('a');
      for(let i = 0; i < anchors.length; i++) {
        try {
          const _url = new URL(anchors[i].getAttribute('href'))
          Object.entries(qs).forEach(qse => _url.searchParams.set(qse[0], qse[1]))
          anchors[i].setAttribute('href', _url.href);
        } catch (err) {
          console.log(err)
        }
      }
      return doc.documentElement.innerHTML
    } catch (err) {
      console.log(err)
    }
    return htmlText
  }
  static escapeHtml(unsafe)
  {
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
  static b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  static formatTimeFrom24to12Hour(timeString) {
    const [hourString, minute] = timeString.split(':');
    const hour = +hourString % 24;
    const suffix = hour < 12 ? ' AM' : ' PM';
    const formattedHour = (hour % 12 || 12).toString().padStart(2, '0');
    return `${formattedHour}:${minute}${suffix}`;
  }

  static getDaysOfWeekLong() {
    const daysOfWeekLong = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    return daysOfWeekLong;
  }

  static getShortDayFromLong(day) {
    const daysOfWeekLong = Helper.getDaysOfWeekLong();
    if(daysOfWeekLong.includes(day)) {
      return day.substr(0, 3)
    }
    return ''
  }

  static debounce(func, delay) {
    let debounceTimer;
    const debounced = function(...args) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(this, args), delay);
    };
    debounced.cancel = function() {
      clearTimeout(debounceTimer);
      debounceTimer = null
    }
    return debounced
  }

  static yearMonthDayHour(timestamp, zoneinfo) {
    if (zoneinfo) {
      return moment(Number(timestamp)).tz(zoneinfo).format('YYYYMMDDHH');
    }
    return moment(Number(timestamp)).format('YYYYMMDDHH');
  }

  static yyyymmddToDate(yyyymmdd, zoneinfo) {
    const a = moment(yyyymmdd, 'YYYYMMDD');
    return a.toDate()
  }

  static areTimezonesEqual(timezone1, timezone2) {
    const referenceMoment = moment();
    const offset1 = moment.tz(referenceMoment, timezone1).utcOffset();
    const offset2 = moment.tz(referenceMoment, timezone2).utcOffset();
    return offset1 === offset2
  }

  static generatePreviousMonthsOrDays(type, count, timezone) {
    const dates = [];
    const tz = timezone || moment.tz.guess();

    let currentDate = moment.tz(tz)

    for (let i = 0; i < count; i++) {
      if (type === 'months') {
        dates.push(currentDate.format('MMM YYYY'))
        currentDate = currentDate.subtract(1, 'month')
      } else if (type === 'days') {
        dates.push(currentDate.format('MMM DD'))
        currentDate = currentDate.subtract(1, 'day')
      }
    }

    return dates.reverse()
  }

  static getHoursIn12HourFormat() {
    const hoursIn12HourFormat = ['12am', '1am', '2am', '3am', '4am', '5am', '6am', '7am', '8am', '9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm', '8pm', '9pm', '10pm', '11pm'];
    return hoursIn12HourFormat;
  }

  static getNextHourTs(timestamp) {
    const date = new Date(timestamp);
    date.setHours(date.getHours() + 1);
    date.setMinutes(0, 0, 0);
    return date.getTime();
  }

  static removeQueryParams(url) {
    try {
      const parsedUrl = new URL(url);
      return `${parsedUrl.hostname}${parsedUrl.pathname}`;
    } catch (error) {
      return url;
    }
  }

  static isShowInternal(appUser) {
    const _url = new URL(document.location.href)
    const showInternal = (
      _url.searchParams.has('showinternal')
      || _url.searchParams.has('showInternal')
      || _url.searchParams.has('showcs')
      || _url.searchParams.has('showCs')
    )
    if (!showInternal) return false
    let user = appUser
    if (user === undefined) {
      try {
        const { Controller } = require('../Controller')
        user = Controller.get() && Controller.get().userMgr() && Controller.get().userMgr().getAppUser()
      } catch (e) {
        // ignore
      }
    }
    if (user) {
      return Helper.isSlixtaStaff(user.email)
    }
    return true
  }

  static isShowDeveloperSettings(appUser) {
    const _url = new URL(document.location.href)
    const showDeveloper = (_url.searchParams.has('showdev') || _url.searchParams.has('showDev'))
    if (!showDeveloper) return false
    let user = appUser
    if (user === undefined) {
      try {
        const { Controller } = require('../Controller')
        user = Controller.get() && Controller.get().userMgr() && Controller.get().userMgr().getAppUser()
      } catch (e) {
        // ignore
      }
    }
    if (user) {
      return Helper.isSlixtaStaff(user.email)
    }
    return true
  }

  static isMobileView() {
    let check = false;
    (function(a) {if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent || navigator.vendor || window.opera);
    if (window.innerWidth <= 1024) {
      check = true;
    }
    return check;
  }

  static copyToClipboard(data) {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(data)
        .then(() => console.log('Copied to clipboard!'))
        .catch((error) => console.error('Failed to copy:', error));
    }
  }

  static getLocalTimezone() {
    return moment.tz.guess()
  }

  static parseStringToHtml(htmlString) {
    const parser = new DOMParser();
    const html = parser.parseFromString(htmlString, 'text/html');
    return html
  }

  static serializeHtmlToString(html) {
    const serializer = new XMLSerializer();
    const htmlString = serializer.serializeToString(html)
    return htmlString
  }

  static dohtmlStringcontainsTag(htmlString, tag) {
    const html = Helper.parseStringToHtml(htmlString)
    return html.querySelector(tag) !== null;
  }

  static isAndroidDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /Android/.test(userAgent);
  }

  static formatLargeNumber(num) {
    num = Number(num)
    if (Number.isNaN(num)) return num

    const format = (value) => {
      const rounded = parseFloat(value.toFixed(2))
      return rounded % 1 === 0 ? Math.round(rounded) : rounded
    }

    if (num >= 1000000000) {
      return format(num / 1000000000) + 'B'
    } else if (num >= 1000000) {
      return format(num / 1000000) + 'M'
    } else if (num >= 10000) {
      return format(num / 1000) + 'K'
    }
    return format(num)
  }

  static capitalizeFirstLetter(string) {
    if (!string) return null;
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  static lowercaseFirstLetter(string) {
    if (!string) return null;
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

  static isWebview() {
    const userAgent = navigator.userAgent;
    const isAndroid = userAgent.includes('Android');
    const isiOS = /iPhone|iPad|iPod/.test(userAgent);

    // Android specific checks
    if (isAndroid && (userAgent.includes('wv') || userAgent.includes('WebView'))) {
      return true;
    }

    // iOS specific checks (absence of "Version/")
    if (isiOS && !/Version\/[\d.]+/.test(userAgent)) {
      return true;
    }

    return false;
  }
  static bufferToObjectUrl(buffer, mimeType) {
    const bytes = new Uint8Array(buffer);
    const blob = new Blob([bytes], { type: mimeType });
    return URL.createObjectURL(blob);
  }

  static downloadBuffer(buffer, mimeType, fileName) {
    const url = Helper.bufferToObjectUrl(buffer, mimeType)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName || 'download'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)

    URL.revokeObjectURL(url)
  }

  static isMacOSSafari() {
    return !!window.safari
  }

  static isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  }

  static isSlixtaStaff(email) {
    const trimmed = (email || '').toLowerCase().trim();
    return Boolean(trimmed && /(^|[@.])(slixta\.com|azympto\.com)$/i.test(trimmed));
  }

  static isProductSU(appUser) {
    if (appUser && Array.isArray(appUser.orgs)) {
      for (let i = 0; i < appUser.orgs.length; i++) {
        const org = appUser.orgs[i]
        if (org.orgId === 'PRODUCT') {
          if (org.role === 'SUPERUSER') return true // for backward compatibility
          if (Helper.inArray(org.roles, 'SUPERUSER')) return true
        }
      }
    }
    return false;
  }

  static toExternalHref(value) {
    if (typeof value !== 'string') {
      return value
    }
    const trimmed = value.trim()
    if (!trimmed || /^[a-z][a-z0-9+.-]*:/i.test(trimmed)) {
      return trimmed
    }
    if (trimmed.startsWith('//')) {
      return 'https:' + trimmed
    }
    return 'https://' + trimmed
  }

  static getFormPreviewComponent(component) {
    if (!component || typeof component !== 'string') {
      return null
    }

    const { FORM_PREVIEW_COMPONENTS } = require('../components/FormPreviewRegistry')
    const previewComponent = FORM_PREVIEW_COMPONENTS[component]
    return previewComponent || null
  }
}
